import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../state/auth/useAuth';
import { getDashboardPath } from '../../utils/navigation';

/**
 * AuthGuard prevents authenticated users from accessing auth pages
 * Redirects to appropriate dashboard based on user role
 */
export default function AuthGuard({ children }) {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) return null; // Could render a spinner

  if (isAuthenticated && user) {
    const redirectPath = getDashboardPath(user.role);
    
    // Replace history to prevent back navigation to auth pages
    return <Navigate to={redirectPath} replace />;
  }

  // Not authenticated, allow access to auth pages
  return children;
}